import { createTheme } from '@material-ui/core'
import GothamMedium from './fonts/GothamMedium.ttf'

export const SIZING = {
    scale25: "0.1rem", // 1.6
    scale50: "0.125rem", // 2
    scale100: "0.25rem", // 4
    scale200: "0.5rem", // 8
    scale300: "0.75rem", // 12
    scale350:"0.875rem",//14
    scale400: "1rem", // 16
    scale500: "1.25rem", // 20
    scale600: "1.5rem", // 24
    scale700: "1.75rem", // 28
    scale800: "2rem", // 32
    scale1000: "2.5rem", // 40
    scale1200: "3rem", // 48
    scale1600:"4rem",//64
    scale2000:"5.25rem",//84
    scale2600:"6.5rem",//104
    scale2800: "7rem", // 112
    scale2900:"7.75rem",//124
    scale3200:"8.85rem",//140
}

export const BORDER_RADIUS = {
    SMALL: SIZING.scale100,
    MEDIUM: SIZING.scale200,
    MED_LARGE: SIZING.scale400,
    LARGE: SIZING.scale600,
    XL: SIZING.scale500,
    PILL: "30rem",
    FULL: "100%",
    MULTISELECT_RADIUS_RIGHT:'1.385rem',
    MULTISELECT_RADIUS_LEFT:'1.3rem'
}

export const PADDING = {
    SIDE_NAV_ITEM_PADDING: "2px",
    SIDE_NAV_WRAPPER_PADDING: "16px"
}

export const COLORS = {

    //Common
    WHITE: "#FFFFFF",
    LBLUE:'#0F7BBD',
    GREY:'#393948',
    DGREY:'#EDEDEF',
    DBLACK:'#393948',

    // Backgrounds
    // nav, menu, tab
    OPTION_MENU_BG: "#393948",
    OPTION_MENU_BG_LIGHT: "#FFFFFF",
    OPTION_DIVIDER_BG: "#9DAAC5",
    SELECTED_TAB_BG: "#FFFFFF",
    SIDE_NAV_BG: "#EDEDEF",
    SIDE_NAV_HEADER_BG: "#F6F6F7",
    LEARNING_CENTER_HEADER_BG: "#EDEDEF",
    LEARNING_CENTER_BG: "#F6F8FA",
    LIST_ITEM_BG: "#FFFFFF",
    SELECTED_SUB_NAV_ITEM_BTN: "linear-gradient(0deg, #FFFFFF, #FFFFFF)",

    BADGE_BG: "#0F7BBD",
    CHAT_HEADER_BG: "#F9F9FB",
    ITEM_COUNT_BG: "#007AFF",
    ITEM_BADGE_BG: "#393948",
    UNREAD_MESSAGE_ICON_BG: "#0F7BBD",
    MESSAGE_LIST_BG: "#F6F8FA",
    MESSAGE_BG: "#FFFFFF",
    HOVER_THREAD_BG: "#E8F5FE",
    SELECTED_THREAD_BG: "#0F7BBD",
    OPENED_THREAD_BG: "#E8F5FE",
    PRIORITY_BG: "#E32B29",
    OWN_MESSAGE_BG: "#E6F7F2",

    // input
    INPUT_BG: "#FFFFFF",
    INPUT_ERROR_BG: "#FFF4F4",
    MULTI_SELECT_BG:'#6E6E79',

    // other
    CALL_STATUS_BG: "#393948",
    MODAL_BG: "#F6F6F7",
    DIVIDER_GREY: "rgba(0, 0, 0, 0.1)",
    COMPOSE_SCROLL_BAR:'#CACACE',
    LGRAY:'#CACACE',
    START_CALL_BG:"#00872A",
    EVIST_INVITE_BG:'#073D5E',
    YELLOW:'#f5e61c',
    CHECKBOX_ICON_BG:'#a8a8af',
    MODAL_BACKDROP_BG: 'linear-gradient(0deg, #F6F6F7, #F6F6F7), #FFFFFF',

    // Buttons
    DEFAULT_BTN: "#0F7BBD",
    PRIMARY_BTN: "#FFFFFF",
    TOOLBAR_BTN: "linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(86, 86, 98, 0.05) 100%), #FFFFFF",
    SELECTED_NAV_LIST_ITEM_BTN: "#E4E4E6",
    SELECTED_NAV_ITEM_BTN: "#FFFFFF",
    SIDE_NAV_COLLAPSE_BTN: "linear-gradient(180deg, rgba(255, 255, 255, 0.6) 0%, rgba(230, 234, 241, 0) 100%), #E6EAF1",
    SECONDARY_BUTTON:'#00875E',
    DISABLED_BTN: "#CACACE",
    SELECTED_BTN: "#073D5E",

    // Text
    SELECTED_NAV_TEXT: "#0F7BBD",
    NAV_TEXT: "#4C535F",
    SELECTED_SUB_NAV_TEXT: "#7E90B3",
    SUB_NAV_TEXT: "#252D3B",
    PARTICIPANT_TEXT: "#007AFF",
    SUBTITLE_TEXT: "rgba(0, 0, 0, 0.4)",
    BODY_TEXT: "#3C3C43",
    ITEM_COUNT_TEXT: "#FFFFFF",
    OPTION_MENU_TITLE_TEXT: "#FFFFFF",
    OPTION_MENU_TITLE_TEXT_LIGHT: "#393948",
    OPTION_MENU_ITEM_TEXT: "#FFFFFF",
    OPTION_MENU_ITEM_TEXT_LIGHT: "#393948",
    LIST_SUBHEADER_TEXT: "#565662",
    DEFAULT_BUTTON_TEXT: "#FFFFFF",
    PRIMARY_BTN_TEXT: "#0B5D8F",
    DIVIDER_TEXT: "#0F7BBD",
    NOTIFICATION_TEXT: "#E32B29",
    ERROR_TEXT: "#D72C0D",
    FORM_SCORE_RED: "#AB201F",
    FORM_SCORE_GREEN:'#00875E',
    EMPTY_LIST_TEXT: "rgba(57, 57, 72, 0.4)",
    PATIENT_DETAIL_VALUE_TEXT: "#393948",
    PATIENT_DETAIL_LABEL_TEXT: "#909098",
    PATIENT_DETAIL_HEADER_TEXT: "#212131",
    LIGHT_BLUE:'#139AED',
    CONVERSATION_TEXT: "#565662",
    OPENED_THREAD_TEXT: "#565662",
    UNREAD_THREAD_TEXT: "#212131",
    LIST_ITEM_TEXT: "#393948",
    LIST_ITEM_TEXT_BLUE: "#0F7BBD",
    PATIENT_TEXT: "#0F7BBD",
    SUBTITLE_INFO_TEXT: "#6E6E79",
    DISABLED_BTN_TEXT: "#565662",
    WAITING_ROOM_CALL_TEXT:"#DBDBDE",

    // Borders
    INPUT_ERROR_BORDER: "#D82C0D",
    NOTIFICATION_BORDER: "#FF5C5A",

    // Icons
    DEFAULT_ICON: "#6E6E79",
    BUTTON_ICON: "#FFFFFF",
    PATIENT_LIST_ICON: "rgba(15, 123, 189, 0.4)",
    USER_LIST_ICON: "rgba(57, 57, 72, 0.4)",
    EMPTY_LIST_ICON: "#EBEBEB",
    USER_ICON: "rgba(86, 86, 98, 0.4)",
    SELECTED_PERSON_ICON: "rgba(255, 255, 255, 0.6)",
    DRAWER_ICON: "#CACACE",
    DARK_ICON: "#565662",
    ALERTS_ICON: "#E82C2A",
    PASS_ICON: "#32D74B",
    FAIL_ICON: "#E32B29",

    //Alert Details
    ALERT_HEADER_BG:"#E8F5FE",
    
    PNG_MODAL_BG:'#F6F6F6'

}

const gothamMedium = {
    fontFamily: "GothamMedium",
    fontStyle: "normal",
    fontDisplay: "swap",
    src: `
        local('GothamMedium'),
        url(${GothamMedium}), format('truetype')
    `
}

export default createTheme({
    breakpoints: {
        values: {
            xxs: 0,
            xs: 400,
            sm: 600,
            md: 960,
            lg: 1280,
            xl: 1920,
            xxl: 2000
        }
    },
    typography: {
        fontFamily: '"Gotham Medium", "Helvetica Neue", Helvetica, Arial, sans-serif',
        h1: {
            weight: 500,
            fontSize: "40px"
        },
        h3: {
            fontWeight: 700,
            fontSize: "20px",
            lineHeight: "normal"
        },
        h4: {
            fontWeight: 700,
            fontSize: "18px",
            lineHeight: "25px"
        },
        h5: {
            fontSize: "12px",
            lineHeight: "16px",
            fontWeight: 700
        },
        h6: {
            fontWeight: 700,
            fontSize: "14px",
            lineHeight: "20px"
        },
        subtitle2: {
            fontWeight: 500,
            fontSize: "12px",
            lineHeight: "20px",
            color: COLORS.SUBTITLE_TEXT
        },
        body1: {
            fontWeight: 700,
            fontSize: "16px",
            lineHeight: "22px"
        },
        body2: {
            fontWeight: 400,
            fontSize: "18px",
            lineHeight: "22px",
            color: COLORS.BODY_TEXT
        },
        subtitle1: {
            fontWeight: 400,
            fontSize: "12px",
            lineHeight: "16px"
        },
        button: {
            fontWeight: 600,
            fontSize: "20px",
            textTransform: "capitalize"
        }
    },
    overrides: {
        MuiCssBaseline: {
            '@global': {
                '@font-face': [gothamMedium],
                '::-webkit-scrollbar': {
                    width: '10px',
                    height: '10px'
                },
                '::-webkit-scrollbar-track': {
                    borderRadius: '50px',
                    backgroundColor: "none"
                },
                '::-webkit-scrollbar-thumb': {
                    backgroundColor: 'rgba(0, 0, 0, 0.1)',
                    borderRadius: '50px',
                    backgroundClip: 'content-box',
                    border: '3px solid transparent'
                }
            }
        },
        MuiButton: {
            root: {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minWidth: SIZING.scale1200,
                height: SIZING.scale1200,
                background: COLORS.DEFAULT_BTN,
                boxShadow: "0px 1px 4px rgba(0, 0, 0, 0.1)",
                borderRadius: BORDER_RADIUS.PILL,
                textTransform: "capitalize",
                color: COLORS.DEFAULT_BUTTON_TEXT,
                "&:hover": {
                    backgroundColor: COLORS.DEFAULT_BTN,
                    boxShadow: "0px 0px 2px rgba(0, 0, 0, 0.25), 0px 4px 8px rgba(0, 0, 0, 0.25)"
                },
                "&:disabled": {
                    background: COLORS.DISABLED_BTN,
                    color: COLORS.DISABLED_BTN_TEXT,
                    boxShadow: "none",
                    cursor: "not-allowed"
                },
                "&:active": {
                    background: COLORS.SELECTED_BTN
                }
            },
            textPrimary: {
                background: COLORS.PRIMARY_BTN,
                color: COLORS.PRIMARY_BTN_TEXT
            },
            containedSecondary: {
                backgroundColor: COLORS.SECONDARY_BUTTON,
                "&:hover": {
                    backgroundColor: COLORS.SECONDARY_BUTTON
                }
            },
            startIcon: {
                "& path": {
                    fill: COLORS.PRIMARY_BTN_TEXT
                }
            },
            text: {
                padding: `0 ${SIZING.scale400}`
            }
        },
        MuiInputBase: {
            root: {
                "& input::-webkit-input-placeholder, input::-ms-input-placeholder, & input::placeholder": {
                    color: "rgba(0, 0, 0, 0.4)",
                },
                background: COLORS.INPUT_BG,
                border: "1px solid rgba(0, 0, 0, 0.2)",
                borderRadius: BORDER_RADIUS.PILL,
                color: "rgba(0, 0, 0, 0.4)",
                fontSize: "18px",
                textTransform: "initial",
                "&$error": {
                    borderColor: COLORS.INPUT_ERROR_BORDER,
                    background: COLORS.INPUT_ERROR_BG
                }
            },
            input: {
                textIndent: SIZING.scale400,
                minHeight: SIZING.scale400,
                padding: 0
            }
        },
        MuiTableCell: {
            root: {
                padding: '10px 5px',
                fontSize: '16px',
                lineHeight: '150%',
                borderBottom: '1px solid #E4E4E6',
                color: '#393948'
            },
            stickyHeader: {
                backgroundColor: '#EDEDEF',
                color: '#393948',
                fontWeight: 600,
                fontSize: '16px'
            },
            paddingCheckbox: {
                padding: '0 10px 0 4px'
            }
        },
        MuiFormControl: {
            root: {
                "&.normal-input": {
                    "& .MuiInputBase-input": {
                        minHeight: `${SIZING.scale400} !important`,
                        padding: `${SIZING.scale200} ${SIZING.scale100}`
                    }
                },
                "&.width-100": {
                    width: '100%'
                }
            }
        },
        MuiDialog: {
            paper: {
                boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.2), inset 0px 0px 0px rgba(0, 0, 0, 0.1)"
            },
        },
        MuiBackdrop: {
            root: {
                backgroundColor: COLORS.MODAL_BACKDROP_BG,
                backdropFilter: "blur(1.5px)"
            }
        },
        MuiRadio: {
            root: {
                paddingLeft: 0,
                "&:hover": {
                    "backgroundColor": "transparent"
                }
            },
            colorSecondary: {
                color: COLORS.MULTI_SELECT_BG,
                "&$checked": {
                    color: COLORS.LIGHT_BLUE,
                    "&:hover": {
                        "backgroundColor": "transparent"
                    }
                }
            }
        }
     }
})